let Utils = {
    collapsing: false,
    collapse: function(id) {
        if(!Utils.collapsing) {
            Utils.collapsing = true;
            let enabled = true;
            if (enabled) {
                enabled = false;
                let container = document.getElementById(`boards-category-${id}`);
                let button = document.getElementById(`collapse-button-${id}`);
                let status = container.dataset.collapse;

                if (status == "no-collapsed") {
                    container.classList.remove("animated", "fadeInUp");
                    button.classList.remove("glyphicons-minus");
                    container.classList.add("animated", "fadeOutUp", "d-none");
                    button.classList.add("glyphicons-plus");
                    container.dataset.collapse = "collapsed";
                } else {
                    container.classList.remove("fadeOutUp", "d-none");
                    button.classList.remove("glyphicons-plus");
                    container.classList.add("fadeInUp");
                    button.classList.add("glyphicons-minus");
                    container.dataset.collapse = "no-collapsed";
                }
                enabled = true
            }
            Utils.collapsing = false;
        }
    }
}
